import React from 'react';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Zap, Clock, MessageSquare, TrendingUp, CheckCircle2, Sparkles, Store, BarChart3, Shield, Workflow, Brain, Globe } from 'lucide-react';

export default function Features() {
  const mainFeatures = [
    {
      icon: <Brain className="h-8 w-8" />,
      title: 'Yapay Zeka Destekli Otomatik Yanıtlama',
      description: 'Gelişmiş Merkur AI teknolojisi ile ürün bilgilerine dayalı, akıllı ve profesyonel müşteri yanıtları oluşturur.',
      benefits: ['Ürün açıklamalarından öğrenir', 'Markanıza özel ton ve dil', 'Sürekli gelişen AI modeli']
    },
    {
      icon: <MessageSquare className="h-8 w-8" />,
      title: 'Hibrit ve Full-Auto Modlar',
      description: 'İhtiyacınıza göre kontrol seviyesini belirleyin.',
      benefits: ['Hibrit: Manuel onay ile kontrol', 'Full-Auto: Tamamen otomatik', 'İstediğiniz zaman mod değişimi']
    },
    {
      icon: <Store className="h-8 w-8" />,
      title: 'Çoklu Mağaza Yönetimi',
      description: 'Trendyol ve Hepsiburada gibi platformları tek yerden yönetin.',
      benefits: ['Sınırsız mağaza bağlantısı', 'Platform bazlı filtreleme', 'Tek ekrandan takip']
    },
    {
      icon: <Clock className="h-8 w-8" />,
      title: '7/24 Otomatik İzleme',
      description: 'Arka planda çalışan sistem gelen soruları otomatik işler.',
      benefits: ['5 dakikada bir kontrol', 'Webhook desteği', 'Anlık bildirimler']
    },
    {
      icon: <BarChart3 className="h-8 w-8" />,
      title: 'Detaylı Analytics',
      description: 'Performans metriklerinizi canlı takip edin.',
      benefits: ['Gerçek zamanlı istatistikler', 'Grafik ve görselleştirmeler', 'Performans raporları']
    },
    {
      icon: <Workflow className="h-8 w-8" />,
      title: 'Özelleştirilebilir Promptlar',
      description: 'Markanıza özel yanıt tonu oluşturun.',
      benefits: ['Özel prompt şablonları', 'Marka sesi uyumlu', 'Esnek düzenleme']
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-orange-100 text-[#FF6000] hover:bg-orange-100">Özellikler</Badge>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Güçlü Özellikler, Kolay Kullanım</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">E-ticaret işinizi bir üst seviyeye taşıyacak AI destekli özellikler</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {mainFeatures.map((feature, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="w-16 h-16 rounded-lg bg-orange-100 text-[#FF6000] flex items-center justify-center mb-4">{feature.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600 mb-4">{feature.description}</p>
                <ul className="space-y-2">
                  {feature.benefits.map((benefit, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                      <CheckCircle2 className="h-4 w-4 text-[#FF6000] mt-0.5 flex-shrink-0" />
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
        <Card className="bg-gradient-to-r from-[#FF6000] to-orange-600 text-white">
          <CardContent className="p-12 text-center">
            <h2 className="text-3xl font-bold mb-4">Hazır mısınız?</h2>
            <p className="text-lg mb-6 opacity-90">Tüm bu özellikleri denemek için hemen başlayın</p>
            <button onClick={() => window.location.href = '/register'} className="bg-white text-[#FF6000] px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors">Ücretsiz Deneyin</button>
          </CardContent>
        </Card>
      </div>
      <Footer />
    </div>
  );
}
